import { FLIGHT_TYPE_REDUCER } from '../../constants/common'

const flightReducer = (state = {}, action: any) => {
    switch (action.type) {
        case FLIGHT_TYPE_REDUCER.SET_FLIGHT_SELECTED_DEPARTURE:
            return {
                ...state,
                selectedDeparture: action.selectedDeparture
            }
        case FLIGHT_TYPE_REDUCER.SET_FLIGHT_SELECTED_RETURN:
            return {
                ...state,
                selectedReturn: action.selectedReturn
            }
        case FLIGHT_TYPE_REDUCER.SET_SEARCH_FLIGHT_CURRENT_TYPE:
            return {
                ...state,
                searchFlightCurrentType: action.searchFlightCurrentType
            }
        default:
            return { ...state }
    }
}

export default flightReducer
